import React, { Component } from 'react'
import { connect } from 'react-redux'

class Brand extends Component {

    searchValue = (category,selectedProd) => {
          // console.log('filerdata',selectedProd,"----",this.props.filterDataValue.brand.includes(selectedProd))
            let selectedFilterValue=this.props.filterDataValue[category]
            
            let checkedValue=selectedFilterValue.includes(selectedProd)
             console.log('search value ',selectedProd ,"props", selectedFilterValue," result value ",checkedValue )
           //console.log('checked value',checkedValue)
           return checkedValue
        // return false;
    }


    render() {
        let brandValues = [];
        if (this.props.brandValue && this.props.brandValue.brandList) {
            this.props.brandValue.brandList.map((brandValueitems, index) => (
                brandValues.push(
                <div>
                    <div> <input className="value" id={brandValueitems.name} type="checkbox" aria-label={brandValueitems.name+ " "+brandValueitems.count+ " "+"items"} checked={this.props.preSelection("brand",brandValueitems.name)}
                        onClick={() => this.props.action("brand", brandValueitems.name,'show-filter')} onKeyPress={() => this.props.action("brand", brandValueitems.name,'show-filter')} />
                        <label for={brandValueitems.name}   >
                            <span className="bg-black" ></span> {brandValueitems.name} ({brandValueitems.count})</label>
                    </div>
                    {/* <div> <input className="value" id={brandValueitems.name} type="checkbox" aria-label={brandValueitems.name+brandValueitems.count+"items"} checked={this.props.preSelection("brand",brandValueitems.name)}
                        onClick={() => this.props.action("brand", brandValueitems.name)} onKeyPress={() => this.props.action("brand", brandValueitems.name)} />
                        <label for={brandValueitems.name} role="checkbox"  >
                            <span className="bg-black" ></span> {brandValueitems.name} ({brandValueitems.count})</label>
                    </div> */}
                </div>
                )))
        }
        return (
            <React.Fragment>
                <div  >
                    <div className="m_accordion-details m_single" style={{ display: this.props.showBrand ? 'none' : 'block' }}>
                        <div className="no-bullet margin-bottom-zero">
                            {brandValues}
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}
const mapStateToProps = (state) => {
    return {


        cartProduct: state.cartProductDataVTP,
        filterDataValue: state.productsVTP.filterData
    }
}
export default (connect(
    mapStateToProps
)(Brand));
